/**
 * Prerender utilities using PerformanceObserver for network idle detection
 */

const _isPrerender =
  typeof window !== 'undefined' && window.appConfig?.IS_BOT === true;

export const isPrerender = (): boolean => _isPrerender;

/**
 * Wait for network idle using PerformanceObserver
 * Tracks ALL resources: fetch, XHR, images, scripts, fonts, CSS
 */
export const waitForNetworkIdle = (
  idleMs = 1500,
  maxMs = 15_000
): Promise<void> =>
  new Promise((resolve) => {
    if (typeof PerformanceObserver === 'undefined') {
      setTimeout(resolve, idleMs);
      return;
    }

    let lastActivity = Date.now();
    let done = false;

    const finish = () => {
      if (done) return;
      done = true;
      observer.disconnect();
    };

    const maxTimer = setTimeout(() => {
      finish();
      resolve();
    }, maxMs);

    const observer = new PerformanceObserver(() => {
      lastActivity = Date.now();
    });

    try {
      observer.observe({ entryTypes: ['resource'] });
    } catch {
      setTimeout(resolve, idleMs);
      return;
    }

    const check = () => {
      if (done) return;
      if (Date.now() - lastActivity >= idleMs) {
        clearTimeout(maxTimer);
        finish();
        resolve();
      } else {
        setTimeout(check, 200);
      }
    };

    setTimeout(check, 500);
  });

/**
 * Initialize prerender - wait for network idle, then signal ready
 */
export const initPrerender = async (): Promise<void> => {
  if (!isPrerender()) {
    (window as any).prerenderReady = true;
    return;
  }

  await waitForNetworkIdle();
  (window as any).prerenderReady = true;
};
